import CommonResultFactory from "./common-result";

const chartDataMap = {
  oer: [
    {
      groupName: "OER ACHIEVEMENT",
      layout: "hbox",
      charts: [
        {
          chartId: "most-recent-cer-average",
          title: "MOST RECENT OER AVERAGE"
        },
        {
          chartId: "most-recent-cer-by-ratings",
          title: "MOST RECENT OER BY RATINGS"
        },
        {
          chartId: "cer-ratings-platform",
          title: "OER RATINGS BY PLATFORMS"
        },
        {
          chartId: "food-safety-by-rating",
          title: "FOOD SAFETY BY RATING"
        },
        {
          chartId: "food-safety-most-missed",
          title: "FOOD SAFETY MOST MISSED"
        },
        {
          chartId: "most-recent-cer-sos",
          title: "MOST RECENT OER SOS"
        },
        {
          chartId: "highest-impact-opportunities",
          title: "HIGHEST IMPACT OPPORTUNITIES"
        },
        {
          chartId: "cer-fuv-visits-by-leader",
          title: "OER CIP VISITS BY RVT"
        }
      ]
    }
  ],
  academy: [
    {
      groupName: "ACADEMY ACHIEVEMENT",

      layout: "hbox",
      charts: [
        {
          chartId: "overall-academy-engagement",
          title: "OVERALL ACADEMY ENGAGEMENT"
        },
        {
          chartId: "overall-academy-avg-skill-quotient",
          title: "OVERALL ACADEMY AVG SKILL QUOTIENT"
        },
        {
          chartId: "academy-patterns-by-category",
          title: "ACADEMY PATTERNS BY CATEGORY"
        },
        {
          chartId: "academy-engagement-by-region",
          title: "ACADEMY ENGAGEMENT BY REGION"
        }
      ]
    }
  ],
  rvt: [
    {
      groupName: "RVT ENGAGEMENT",

      layout: "hbox",
      charts: [
        {
          chartId: "leader-daily-visit-engagement",
          title: "RVT DAILY VISIT ENGAGEMENT"
        }/* ,
        {
          chartId: "kpi-alerts-triggered-and-actioned",
          title: "KPI ALERTS TRIGGERED & ACTIONED"
        },
        {
          chartId: "rm-reported-and-actioned",
          title: "R&M REPORTED & ACTIONED"
        },
        {
          chartId: "before-and-after-follow-up-photos",
          title: "BEFORE & AFTER FOLLOW UP PHOTOS"
        } */
        ,
        {
          chartId: "our-routines-complete-by-kpi",
          title: "OUR ROUTINES % COMPLETE BY KPI"
        },
        {
          chartId: "our-routines-patterns-by-daypart",
          title: "OUR ROUTINES PATTERNS BY DAYPART"
        },
        {
          chartId: "our-routines-engagement-by-region",
          title: "OUR ROUTINES ENGAGEMENT BY REGION"
        }
      ]
    }
  ],
  overall: [
    {
      groupName: "RESTAURANT ACHIEVEMENT",
      type: 'restaurant-charts',

      layout: "hbox",
      charts: [
        //按照目前需求，暂时隐藏以下项
        // {
        //   chartId: "overall-academy-engagement",
        //   title: "OVERALL ACADEMY ENGAGEMENT"
        // },
        {
          chartId: "most-recent-cer-average",
          title: "MOST RECENT OER AVERAGE"
        },
        // {
        //   chartId: "projected-versus-reported-sales",
        //   title: "PROJECTED VERSUS REPORTED SALES"
        // },
        // {
        //   chartId: "our-daily-routines-engagement-avg",
        //   title: "OUR DAILY ROUTINES ENGAGEMENT AVG"
        // }
        {
          chartId: "leader-daily-visit-engagement",
          title: "RVT DAILY VISIT ENGAGEMENT"
        }
      ]
    },
    {
      //groupName: "Routines Performance",
      groupName: "ROUTINES PERFORMANCE",
      layout: "hbox",
      charts: [
        {
          chartId: "our-daily-routines-engagement-avg",
          title: "OUR DAILY ROUTINES ENGAGEMENT AVG"
        },
        {
          chartId: "our-routines-complete-by-kpi",
          title: "OUR ROUTINES % COMPLETE BY KPI"
        },
        {
          chartId: "our-routines-patterns-by-daypart",
          title: "OUR ROUTINES PATTERNS BY DAYPART"
        },
        {
          chartId: "our-routines-engagement-by-region",
          title: "OUR ROUTINES ENGAGEMENT BY REGION"
        }
      ]
    }, {
      groupName: "TEMPERATURE DETAIL",
      layout: "vbox",
      charts: [
        {
          chartId: "our-routines-temperature-detail",
          title: "TEMPERATURE COMPLETION TREND"
        },
      ]
    },
    {
      groupName: "ACHIEVEMENT OVERVIEW",
      layout: "vbox",
      charts: [
        {
          chartId: "our-performance-by-region",
          title: "OUR PERFORMANCE BY REGION"
        }
      ]
    },
    {
      groupName: "AREA OVERVIEW",
      layout: "vbox",
      charts: [
        {
          chartId: "our-routines-complete-by-am",
          title: "OUR ROUTINES % COMPLETE BY MARKET LEADER",
          chartType: "area-overview-by-am",
        },
      ]
    }
  ],
  routines: [
    {
      groupName: "DAILY ROUTINES OVERALL ACHIEVEMENT",
      charts: [
        {
          chartId: "our-daily-routines-engagement-avg",
          title: "OUR DAILY ROUTINES ENGAGEMENT AVG"
        },
        {
          chartId: "our-routines-complete-by-kpi",
          title: "OUR ROUTINES % COMPLETE BY KPI"
        },
        {
          chartId: "our-routines-patterns-by-daypart",
          title: "OUR ROUTINES PATTERNS BY DAYPART"
        },
        {
          chartId: "our-routines-engagement-by-region",
          title: "OUR ROUTINES ENGAGEMENT BY REGION"
        }
      ]
    }
    // ,
    // {
    //   groupName: "DAILY ROUTINES % COMPLETE PATTERNS",
    //   charts: [
    //     {
    //       chartId: "routine-complete-by-opening-checklist",
    //       title: "% COMPLETE BY OPENING CHECKLIST",
    //       chartType: "routine-complete-by-status"
    //     },
    //     {
    //       chartId: "routine-complete-by-closing-checklist",
    //       title: "% COMPLETE BY CLOSING CHECKLIST",
    //       chartType: "routine-complete-by-status"
    //     },
    //     {
    //       chartId: "routine-complete-by-produce-cook-outs",
    //       title: "% COMPLETE BY PRODUCE COOK OUTS",
    //       chartType: "routine-complete-by-status"
    //     },
    //     {
    //       chartId: "routine-complete-by-quality-check",
    //       title: "% COMPLETE BY QUALITY CHECK",
    //       chartType: "routine-complete-by-status"
    //     },
    //     {
    //       chartId: "routine-complete-by-boh-travel-path",
    //       title: "% COMPLETE BY BOH TRAVEL PATH",
    //       chartType: "routine-complete-by-status"
    //     },
    //     {
    //       chartId: "routine-complete-by-foh-travel-path",
    //       title: "% COMPLETE BY FOH TRAVEL PATH",
    //       chartType: "routine-complete-by-status"
    //     },
    //     {
    //       chartId: "routine-complete-by-full-travel-path",
    //       title: "% COMPLETE BY FULL TRAVEL PATH",
    //       chartType: "routine-complete-by-status"
    //     }
    //   ]
    // }
  ],
  overallLeader: [
    {
      groupName: "ACHIEVEMENT OVERVIEW",
      charts: [
        {
          chartId: "our-performance-by-region",
          title: "OUR ROUTINES PERFORMANCE"
        }
      ]
    }
  ]
};

export const getCharts = req => {
  let url = req.url,
    data;
  // if (url.indexOf("viewBy=LeaderRollUps") >= 0) {
  //   if (url.indexOf("view=overall") >= 0) data = chartDataMap["overallLeader"];
  //   return CommonResultFactory.success(data);
  // }
  if (url.indexOf("view=oer") >= 0) data = chartDataMap["oer"];
  else if (url.indexOf("view=academy") >= 0) data = chartDataMap["academy"];
  else if (url.indexOf("view=overall") >= 0) data = chartDataMap["overall"];
  else if (url.indexOf("view=routines") >= 0) data = chartDataMap["routines"];
  else if (url.indexOf("view=rvt") >= 0) data = chartDataMap["rvt"];

  return CommonResultFactory.success(data);
};

export const getViews = req => {
  let viewsData = {
    views: [
      {
        label: "Overall Summary",
        id: "overall"
      },/*
      {
        label: "Routines",
        id: "routines"
      }, */
      // {
      //   label: "Academy",
      //   id: "academy"
      // },
      /*       {
              label: "OER",
              id: "oer"
            },
            {
              label: "RVT",
              id: "rvt"
            }, */
      // {
      //   label: "Combined KPIs",
      //   id: "combined-kpis"
      // },
      // {
      //   label: "Restaurant Summary",
      //   id: "restaurant-summary"
      // }
    ],
    default: "overall",
    autoSelect: true,
  };
  // if (process.env.NODE_ENV !== "production")viewsData.default = 'cer';

  return CommonResultFactory.success(viewsData);
};



// WEBPACK FOOTER //
// ./src/mock/dashboard.js